


















import { Vue, Component, Provide } from "vue-property-decorator";

const naviLang: string = navigator.language;

@Component({
  name: "DetectLang"
})
export default class DetectLang extends Vue {
  @Provide() notice = false;

  beforeMount() {
    if (
      this.$route.name === "detect-lang" &&
      this.$route.params.lang !== "de" &&
      this.$route.params.lang !== "en"
    ) {
      if (naviLang === "de") {
        this.$router.replace({ path: "/de" });
      } else {
        this.$router.replace({ path: "/de" });
      }
    } else if (
      (naviLang === "de" && this.$route.params.lang !== "de") ||
      (naviLang === "en" && this.$route.params.lang !== "en")
    ) {
      this.notice = true;
    }
  }

  switchLang(lang: string) {
    this.notice = false;
    this.$router.push({ name: this.$route.name ? this.$route.name : 'home', params: { lang: lang } });
  }
}
